/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ClientRegistrationRequest,
    ClientRegistrationResponse,
    ConsentDecision,
    ConsentPrompt,
    ConsentRedirect,
    GetOauthConsentParams,
    OAuthError,
    TokenRequestForm,
    TokenResponse,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getOauthConsent = (
    params: GetOauthConsentParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ConsentPrompt>> => {
    return axios.get(`/api/oauth/consent`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetOauthConsentQueryKey = (params?: GetOauthConsentParams) => {
    return [`/api/oauth/consent`, ...(params ? [params] : [])] as const;
};

export const getGetOauthConsentQueryOptions = <
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetOauthConsentQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getOauthConsent>>
    > = ({ signal }) => getOauthConsent(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getOauthConsent>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOauthConsentQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOauthConsent>>
>;
export type GetOauthConsentQueryError = AxiosError<OAuthError>;

export function useGetOauthConsent<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOauthConsent>>,
                    TError,
                    Awaited<ReturnType<typeof getOauthConsent>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthConsent<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOauthConsent>>,
                    TError,
                    Awaited<ReturnType<typeof getOauthConsent>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthConsent<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOauthConsent<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOauthConsentQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOauthConsentSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetOauthConsentQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getOauthConsent>>
    > = ({ signal }) => getOauthConsent(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOauthConsent>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOauthConsentSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOauthConsent>>
>;
export type GetOauthConsentSuspenseQueryError = AxiosError<OAuthError>;

export function useGetOauthConsentSuspense<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthConsentSuspense<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthConsentSuspense<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOauthConsentSuspense<
    TData = Awaited<ReturnType<typeof getOauthConsent>>,
    TError = AxiosError<OAuthError>,
>(
    params: GetOauthConsentParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthConsent>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOauthConsentSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postOauthConsent = (
    consentDecision: ConsentDecision,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ConsentRedirect>> => {
    return axios.post(`/api/oauth/consent`, consentDecision, options);
};

export const getPostOauthConsentMutationOptions = <
    TError = AxiosError<OAuthError>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postOauthConsent>>,
        TError,
        { data: ConsentDecision },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postOauthConsent>>,
    TError,
    { data: ConsentDecision },
    TContext
> => {
    const mutationKey = ["postOauthConsent"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postOauthConsent>>,
        { data: ConsentDecision }
    > = (props) => {
        const { data } = props ?? {};

        return postOauthConsent(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostOauthConsentMutationResult = NonNullable<
    Awaited<ReturnType<typeof postOauthConsent>>
>;
export type PostOauthConsentMutationBody = ConsentDecision;
export type PostOauthConsentMutationError = AxiosError<OAuthError>;

export const usePostOauthConsent = <
    TError = AxiosError<OAuthError>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postOauthConsent>>,
            TError,
            { data: ConsentDecision },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postOauthConsent>>,
    TError,
    { data: ConsentDecision },
    TContext
> => {
    return useMutation(
        getPostOauthConsentMutationOptions(options),
        queryClient
    );
};
export const getOauthPing = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<unknown>> => {
    return axios.get(`/api/oauth/ping`, options);
};

export const getGetOauthPingQueryKey = () => {
    return [`/api/oauth/ping`] as const;
};

export const getGetOauthPingQueryOptions = <
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getOauthPing>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOauthPingQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOauthPing>>> = ({
        signal,
    }) => getOauthPing({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getOauthPing>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOauthPingQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOauthPing>>
>;
export type GetOauthPingQueryError = AxiosError<unknown>;

export function useGetOauthPing<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOauthPing>>,
                    TError,
                    Awaited<ReturnType<typeof getOauthPing>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthPing<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOauthPing>>,
                    TError,
                    Awaited<ReturnType<typeof getOauthPing>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthPing<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOauthPing<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOauthPingQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOauthPingSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getOauthPing>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOauthPingQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOauthPing>>> = ({
        signal,
    }) => getOauthPing({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOauthPing>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOauthPingSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOauthPing>>
>;
export type GetOauthPingSuspenseQueryError = AxiosError<unknown>;

export function useGetOauthPingSuspense<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthPingSuspense<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOauthPingSuspense<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOauthPingSuspense<
    TData = Awaited<ReturnType<typeof getOauthPing>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOauthPing>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOauthPingSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postOauthRegister = (
    clientRegistrationRequest: ClientRegistrationRequest,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ClientRegistrationResponse>> => {
    return axios.post(
        `/api/oauth/register`,
        clientRegistrationRequest,
        options
    );
};

export const getPostOauthRegisterMutationOptions = <
    TError = AxiosError<OAuthError>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postOauthRegister>>,
        TError,
        { data: ClientRegistrationRequest },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postOauthRegister>>,
    TError,
    { data: ClientRegistrationRequest },
    TContext
> => {
    const mutationKey = ["postOauthRegister"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postOauthRegister>>,
        { data: ClientRegistrationRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postOauthRegister(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostOauthRegisterMutationResult = NonNullable<
    Awaited<ReturnType<typeof postOauthRegister>>
>;
export type PostOauthRegisterMutationBody = ClientRegistrationRequest;
export type PostOauthRegisterMutationError = AxiosError<OAuthError>;

export const usePostOauthRegister = <
    TError = AxiosError<OAuthError>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postOauthRegister>>,
            TError,
            { data: ClientRegistrationRequest },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postOauthRegister>>,
    TError,
    { data: ClientRegistrationRequest },
    TContext
> => {
    return useMutation(
        getPostOauthRegisterMutationOptions(options),
        queryClient
    );
};
export const postOauthToken = (
    tokenRequestForm: TokenRequestForm,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TokenResponse>> => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`grant_type`, tokenRequestForm.grant_type);
    if (
        tokenRequestForm.client_id !== undefined &&
        tokenRequestForm.client_id !== null
    ) {
        formUrlEncoded.append(`client_id`, tokenRequestForm.client_id);
    }
    if (
        tokenRequestForm.client_secret !== undefined &&
        tokenRequestForm.client_secret !== null
    ) {
        formUrlEncoded.append(`client_secret`, tokenRequestForm.client_secret);
    }
    if (tokenRequestForm.code !== undefined && tokenRequestForm.code !== null) {
        formUrlEncoded.append(`code`, tokenRequestForm.code);
    }
    if (
        tokenRequestForm.redirect_uri !== undefined &&
        tokenRequestForm.redirect_uri !== null
    ) {
        formUrlEncoded.append(`redirect_uri`, tokenRequestForm.redirect_uri);
    }
    if (
        tokenRequestForm.code_verifier !== undefined &&
        tokenRequestForm.code_verifier !== null
    ) {
        formUrlEncoded.append(`code_verifier`, tokenRequestForm.code_verifier);
    }
    if (
        tokenRequestForm.refresh_token !== undefined &&
        tokenRequestForm.refresh_token !== null
    ) {
        formUrlEncoded.append(`refresh_token`, tokenRequestForm.refresh_token);
    }

    return axios.post(`/api/oauth/token`, formUrlEncoded, options);
};

export const getPostOauthTokenMutationOptions = <
    TError = AxiosError<OAuthError>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postOauthToken>>,
        TError,
        { data: TokenRequestForm },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postOauthToken>>,
    TError,
    { data: TokenRequestForm },
    TContext
> => {
    const mutationKey = ["postOauthToken"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postOauthToken>>,
        { data: TokenRequestForm }
    > = (props) => {
        const { data } = props ?? {};

        return postOauthToken(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostOauthTokenMutationResult = NonNullable<
    Awaited<ReturnType<typeof postOauthToken>>
>;
export type PostOauthTokenMutationBody = TokenRequestForm;
export type PostOauthTokenMutationError = AxiosError<OAuthError>;

export const usePostOauthToken = <
    TError = AxiosError<OAuthError>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postOauthToken>>,
            TError,
            { data: TokenRequestForm },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postOauthToken>>,
    TError,
    { data: TokenRequestForm },
    TContext
> => {
    return useMutation(getPostOauthTokenMutationOptions(options), queryClient);
};
